import { render, staticRenderFns } from "./autoUpload.vue?vue&type=template&id=887de2ba"
import script from "./autoUpload.vue?vue&type=script&lang=js"
export * from "./autoUpload.vue?vue&type=script&lang=js"
import style0 from "./autoUpload.vue?vue&type=style&index=0&id=887de2ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports